import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { User } from 'lucide-react';

import { API } from '../../config';

const AdminUsers = () => {
  const [list, setList] = useState([]);
  useEffect(() => {
    const load = async () => {
      const t = localStorage.getItem('tp_admin_token');
      const r = await axios.get(`${API}/admin/users`, { headers: { Authorization: `Bearer ${t}` } });
      setList(r.data);
    };
    load();
  }, []);
  return (
    <div>
      <h1 className="text-2xl font-bold text-[#0B2E5C]">Users</h1>
      <p className="text-sm text-gray-500 mb-5">{list.length} users registered</p>
      <div className="bg-white rounded-xl border border-gray-100 card-shadow overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 text-xs text-gray-500 uppercase">
            <tr><th className="text-left py-3 px-4">User</th><th className="text-left py-3 px-4">Mobile</th><th className="text-left py-3 px-4">Orders</th><th className="text-left py-3 px-4">Registered</th></tr>
          </thead>
          <tbody>
            {list.map(u => (
              <tr key={u.id} className="border-t">
                <td className="py-3 px-4"><div className="flex items-center gap-2"><div className="w-8 h-8 rounded-full bg-[#FFF3E6] text-tp-orange flex items-center justify-center"><User size={14} /></div><span>{u.name || 'User'}</span></div></td>
                <td className="py-3 px-4">+91 {u.mobile}</td>
                <td className="py-3 px-4">{u.orders_count || 0}</td>
                <td className="py-3 px-4 text-xs text-gray-500">{new Date(u.created_at).toLocaleDateString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {list.length === 0 && <div className="text-center py-10 text-gray-400">No users yet</div>}
      </div>
    </div>
  );
};

export default AdminUsers;
